import { HUMAN_INPUT_DATA_TYPE } from "./constants";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface DataTypeSelectorProps {
  dataType: "number" | "string" | undefined;
  onDataTypeChange: (dataType: "number" | "string") => void;
  isValid: boolean;
  disabled?: boolean;
}

const DataTypeSelector = ({
  dataType,
  onDataTypeChange,

  disabled = false,
}: DataTypeSelectorProps) => (
  <Select value={dataType || undefined} onValueChange={onDataTypeChange} disabled={disabled}>
    <SelectTrigger className="w-full">
      <SelectValue placeholder="Select a data type..." />
    </SelectTrigger>
    <SelectContent>
      {Object.entries(HUMAN_INPUT_DATA_TYPE).map(([type, config]) => (
        <SelectItem key={type} value={type}>
          {config.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default DataTypeSelector;
